import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import { FaLeaf, FaLock, FaUser, FaEye, FaEyeSlash, FaShieldAlt } from 'react-icons/fa';

export default function AdminLogin() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginAdmin(form.username, form.password);
      toast.success('Welcome back, Admin!');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Left Panel */}
      <div className="login-left">
        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <img
            src="/logo.png"
            alt="Sri Karunasai Logo"
            style={{
              width: 100, height: 100,
              borderRadius: '50%',
              objectFit: 'contain',
              margin: '0 auto 20px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
              background: 'white',
              display: 'block'
            }}
          />
          <h1 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 26, fontWeight: 800, marginBottom: 12, lineHeight: 1.3 }}>
            Sri Karunasai<br />Medicinal Plantation<br />Association
          </h1>
          <p style={{ opacity: 0.85, fontSize: 15, lineHeight: 1.7, marginBottom: 32 }}>
            Manage your association's membership, registrations, and communications from the central admin panel.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, textAlign: 'left' }}>
            {['Manage all member registrations', 'Export data as CSV', 'Real-time member chat support', 'Add & manage admin accounts'].map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, opacity: 0.9 }}>
                <div style={{ width: 20, height: 20, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>✓</div>
                {f}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="login-right">
        <div style={{ width: '100%', maxWidth: 380 }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 36 }}>
            <img
              src="/logo.png"
              alt="Sri Karunasai Logo"
              style={{
                width: 46, height: 46,
                borderRadius: '50%',
                objectFit: 'contain',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                background: 'white'
              }}
            />
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>Admin Panel</div>
              <div style={{ fontSize: 12, color: '#6b7280' }}>Sri Karunasai MPA</div>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <div style={{ width: 36, height: 36, background: '#f0fdf4', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FaShieldAlt color="#16a34a" size={16} />
            </div>
            <h2 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 22, fontWeight: 700, color: '#111827' }}>
              Admin Login
            </h2>
          </div>
          <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 28 }}>
            Sign in to access the admin dashboard
          </p>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div className="form-group">
              <label className="form-label">Username or Email</label>
              <div style={{ position: 'relative' }}>
                <FaUser style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: 14 }} />
                <input
                  className="form-input"
                  style={{ paddingLeft: 40 }}
                  type="text"
                  placeholder="Enter username or email"
                  value={form.username}
                  onChange={e => setForm({ ...form, username: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <FaLock style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: 14 }} />
                <input
                  className="form-input"
                  style={{ paddingLeft: 40, paddingRight: 44 }}
                  type={showPass ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none', cursor: 'pointer', color: '#9ca3af' }}
                >
                  {showPass ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: 13 }}>
              {loading ? <><div className="spinner" style={{ width: 18, height: 18, borderWidth: 2 }} /> Signing in...</> : 'Sign In to Admin Panel'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <button
              onClick={() => navigate('/user/login')}
              style={{ fontSize: 13, color: '#6b7280', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Member? <span style={{ color: '#16a34a', fontWeight: 600 }}>Login here →</span>
            </button>
          </div>

          <div style={{ textAlign: 'center', marginTop: 12 }}>
            <button
              onClick={() => navigate('/')}
              style={{ fontSize: 13, color: '#9ca3af', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
